<template>
    <div>
        <breadCrumb 
            :icon="'fa-lock-alt'"
            :category="$t(`nav.change_loyalty_password`)"
            :subCategory="''"
            :subSubCategory="''">
        </breadCrumb>
        <div class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-container">
                    <div class="panel-content">
                        <form @submit.prevent="changePassword">
                            <div class="form-group">
                                <label class="form-label">{{$t('label.outlet')}}</label>
                                <div class="input-group-prepend w-100">
                                    <label class="input-group-text bg-transparent border-top-right-radius-0 border-bottom-right-radius-0 border-right-0">
                                        <i class="fas fa-store"></i>
                                    </label>
                                    <multiselect v-model="selectedOutlet" label="text" track-by="id" :options="outlet" :searchable="false" :show-labels="false" openDirection="below" @select="selectOutlet">
                                        <template slot="option" slot-scope="{ option }">{{option.text}}</template>
                                    </multiselect>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">{{$t('label.contact')}}</label>
                                <div class="input-group bg-white shadow-inset-2">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text bg-transparent border-right-0">
                                            <i class="fas fa-phone-alt"></i>
                                        </span>
                                    </div>
                                    <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.contact')" v-model="contact" @keyup="contactValidation">
                                </div>
                                <div id="errContact" class="error-validation"></div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">{{$t('label.password')}}</label>
                                <div class="input-group bg-white shadow-inset-2">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text bg-transparent border-right-0">
                                            <i class="fas fa-lock"></i>
                                        </span>
                                    </div>
                                    <input :type="newType" class="form-control bg-transparent pl-3" :placeholder="$t('label.password')" v-model="newPassword">
                                    <a class="show-password-icon link" @click="newType = newType == 'password' ? 'text' : 'password'">
                                        <i class="fas" :class="newType == 'password' ? 'fa-eye-slash' : 'fa-eye'"></i>
                                    </a>
                                </div>
                            </div>
                            <div class="form-group mb-1">
                                <label class="form-label">{{$t('label.confirmed_password')}}</label>
                                <div class="input-group bg-white shadow-inset-2">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text bg-transparent border-right-0">
                                            <i class="fas fa-lock"></i>
                                        </span>
                                    </div>
                                    <input :type="confirmType" class="form-control bg-transparent pl-3" :placeholder="$t('label.confirmed_password')" v-model="confirmPassword" @keyup="validateNewAndConfirmPassword">
                                    <a class="show-password-icon link" @click="confirmType = confirmType == 'password' ? 'text' : 'password'">
                                        <i class="fas" :class="confirmType == 'password' ? 'fa-eye-slash' : 'fa-eye'"></i>
                                    </a>
                                </div>
                            </div>
                            <div id="err" class="error-validation"></div>
                            <div class="text-left mt-5">
                                <button type="submit" class="btn border-0 btn-primary btn-padding waves-effect waves-themed">{{$t('button_link.save')}}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import BreadCrumb from './../Bread_Crumb'
import {handleSessionExpired} from './../../../assets/js/dashboard/dashboard'
import {contactValidation} from './../../../assets/js/dashboard/utilities'
export default {
    name: "changePassword",
    components:{
        BreadCrumb
    },
    data(){
        return{
            contact: "", newPassword: "", confirmPassword: "",
            newType: "password", confirmType: "password", 
            outlet: [], selectedOutlet: {},
        }
    },
    methods:{
        validateNewAndConfirmPassword(){
            document.getElementById('err').innerHTML = this.newPassword != this.confirmPassword ? this.$i18n.t('message.error.diff_password') : null
        },
        contactValidation(){
            var err = contactValidation(this.contact);
            document.getElementById('errContact').innerHTML = err == null ? null : this.$i18n.t('message.contact_validation.phone_number', {
                'error':  this.$i18n.t(`message.contact_validation.error.${err}`)
            })
        },
        selectOutlet(item){
            this.selectedOutlet = item;
        },
        changePassword(){
            let $vm = this;
            var data = {
                mobile: this.contact,
                password: this.confirmPassword,
            }
            let url = this.$api.OUTLET + "/" + this.selectedOutlet.id + this.$api.CHANGE_LOYALTY_PASSWORD
            $vm.$axios({
                method: 'post', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
                data: data,
            })
            .then((response) => {
                if(response.status == 200){
                    $vm.$parent.setModal($vm, false, true, $vm.$i18n.t('message.success.loyalty_password'));
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();  
                }else{
                    $vm.$parent.setModal($vm, true, true, $vm.$i18n.t('message.error.system_error'));
                }
            })
        },
        closeModal(isError){
            this.$parent.isModalShow = false;
        }
    },
    mounted(){
        let $vm = this;
        $vm.outlet = JSON.parse($vm.$store.state.outlets);
        $vm.selectedOutlet = $vm.outlet[0];
    }
}
</script>
<style scoped>
.show-password-icon{
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 999;
}
.link{
    cursor: pointer;
}
.error-validation{
    font-size: 0.6875rem;
    margin-top: 0.325rem;
    color: #fd3995;
}
</style>